export const iconFontAwesomeArrowsChevronLeft = (
	<i className="fa-solid fa-chevron-left"></i>
);
